import 'css-chunksrc/client/scenes/comments/chatInput/styles.scss';export default {
  "chatInput": "_chatInput_1oi35_1",
  "noBorder": "_noBorder_1oi35_10",
  "submitButton": "_submitButton_1oi35_16",
  "footer": "_footer_1oi35_20",
  "list": "_list_1oi35_32",
  "iconBox": "_iconBox_1oi35_39",
  "icon": "_icon_1oi35_39"
};